
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Dodaj do swojego Ekranu Głównego, aby uzyskać bogate doświadczenie i łatwy dostęp.`,
's1b9047d53d9f9d22': `2) Wybierz "Udostępnij"`,
's37a9e8aec5713460': `Więcej`,
's5c6aad7a7e4a1437': `3) Wybierz "Dodaj do Ekranu Głównego"`,
's6196153c4b0c1ea0': `Zainstaluj`,
's922329d6f6213590': `Dodaj do Docka`,
'sa5ef80b4bb9b39f8': `Mniej`,
'sa7551383d1897fcc': `2) Wybierz "Dodaj do Docka"`,
'sba52286c21552a4e': `Zainstaluj na swoim urządzeniu, aby uzyskać bogate doświadczenie i łatwy dostęp.`,
'sc79fd7641eb9a975': `Ukryj instrukcję`,
'scdaf4bbff76674c8': `Dodaj do Ekranu Głównego`,
'sdfe23506a3b0cdc8': `1) Otwórz przeglądarkę Safari`,
'se740f75b95a51807': `Dodaj do swojego Docka, aby uzyskać bogate doświadczenie i łatwy dostęp.`,
'sfea652f6580ff086': `Ta strona posiada funkcje aplikacji.`,
    };
  